import {
  Auth0AccountRole,
  MeetingAdminResponse,
  MeetingLimitedResponse,
} from "client/openapi";
import { Dialog, DialogTrigger } from "components/Dialog";
import MeetingDialog from "components/MeetingDialog";
import moment from "moment";
import { useState } from "react";
import { returnSubjectName } from "util/concatenateSubject";
import { getAttendees } from "util/getAttendees";
import { LockClosedIcon } from "@radix-ui/react-icons";

function generateColor(id: number): string {
  if (id % 5 === 0) {
    return "pink";
  } else if (id % 5 === 1) {
    return "yellow";
  } else if (id % 5 === 2) {
    return "purple";
  } else if (id % 5 === 3) {
    return "slate-blue";
  } else {
    return "blue";
  }
}

export default function Meeting({
  meeting,
  meetings,
  index,
  role,
  setEvents,
  showAllDetails = false,
  displayStart,
  displayEnd,
}: {
  meeting: MeetingAdminResponse | MeetingLimitedResponse;
  meetings: MeetingAdminResponse[] | MeetingLimitedResponse[];
  index: number;
  role: Auth0AccountRole;
  setEvents: () => Promise<void>;
  showAllDetails?: boolean;
  displayStart?: Date;
  displayEnd?: Date;
}) {
  const [updatedMeeting, setUpdatedMeeting] = useState<
    MeetingAdminResponse | MeetingLimitedResponse
  >(meeting);

  // Prevent the dialog from mounting prematurely
  const [open, setOpen] = useState(false);

  return (
    <Dialog key={meeting.id} open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <div
          className={`calendar--day-event calendar--day-event-${generateColor(
            updatedMeeting.session.id
          )} cursor-pointer${
            updatedMeeting.locked ? " calendar--day-event-locked" : ""
          }`}
        >
          <b className="calendar--day-title">
            {updatedMeeting.name
              ? updatedMeeting.name
              : returnSubjectName(updatedMeeting.org_subject)}
            {updatedMeeting.locked && (
              <LockClosedIcon
                className="calendar--day-event-lock-icon"
                width={10}
                height={10}
              />
            )}
          </b>

          <p className="calendar--day-time">
            {moment(displayStart ?? updatedMeeting.start).format("h:mma")}-
            {displayEnd
              ? moment(displayEnd).format("h:mma")
              : moment(updatedMeeting.start)
                  .add(updatedMeeting.duration, "minutes")
                  .format("h:mma")}
          </p>

          {(updatedMeeting.duration >= 30 || showAllDetails) && (
            <p className="mb-1 leading-tight calendar--day-time">
              {getAttendees(role, updatedMeeting)}
            </p>
          )}

          {(updatedMeeting.duration >= 45 || showAllDetails) && (
            <p className="mb-1 leading-tight calendar--day-time">
              {updatedMeeting.location?.name || updatedMeeting.other_location}
            </p>
          )}
        </div>
      </DialogTrigger>

      {open && (
        <MeetingDialog
          role={role}
          event={updatedMeeting}
          setEvents={setEvents}
        />
      )}
    </Dialog>
  );
}
